import { useEffect, useState } from 'react';

/**
 * Blob preview for a chosen file. The object URL is revoked when the file
 * changes and when the component unmounts. Pass null to drop the preview.
 */
export function useBlobPreview(file: File | null): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!file) return;
    const objectUrl = URL.createObjectURL(file);
    let cancelled = false;
    // Deferred so the effect itself does not set state synchronously.
    queueMicrotask(() => {
      if (!cancelled) setUrl(objectUrl);
    });
    return () => {
      cancelled = true;
      URL.revokeObjectURL(objectUrl);
    };
  }, [file]);

  return file ? url : null;
}
